<script lang="ts" setup>
import { computed } from "vue";

import LandingView from "@/modules/landing/views/LandingView.vue";
import AlgemeneVoorwaardenView from "@/modules/legal/views/AlgemeneVoorwaardenView.vue";
import PrivacybeleidView from "@/modules/legal/views/PrivacybeleidView.vue";

const routes: Record<string, typeof LandingView> = {
  "/algemene-voorwaarden": AlgemeneVoorwaardenView,
  "/privacybeleid": PrivacybeleidView,
};

const currentView = computed(() => {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  return routes[path] ?? LandingView;
});
</script>

<template>
  <VApp>
    <component :is="currentView" />
  </VApp>
</template>
